import React, { useEffect, useState } from "react";
import { withRequest } from "../../../utils/request";
import ReporteVehiculos from "./ReporteVehiculos";
import ProduccionMensual from "./ProduccionMensual";
import ReporteFechas from "./ReporteFechas";
import Select from "react-select";
import ReporteItems from "./ReporteItems";
import ReporteEmpleados from "./ReporteEmpleados";
import { getLink, toast } from "../../../utils/helpers";
import ReporteRutas from "./ReporteRutas";
import { apiRequest } from "../../../hooks/apiRequest";
import Loader from "../../general/Loader";

const ReportesForm = ({toggle}) => {
    const [errors, setErrors] = useState({});
    const [vehiculos, setVehiculos] = useState([]);
    const [ficha, setFicha] = useState("");
    const [tipo, setTipo] = useState("cierre-ano");
    const [loading, setLoading] = useState(false);

    const getVehiculos = async () => {
        setLoading(true);
        const response = await apiRequest(
            null,
            'vehiculos',
            "GET"
        );

        if (response.data && response.data.length) {
            setVehiculos(response.data);
        }
        setLoading(false);
    };

    const updateList = (id) => {
        setVehiculos(vehiculos.map((vehiculo) => {
            if (vehiculo.id === id) {
                vehiculo.checked = !vehiculo.checked;
            }
            return vehiculo;
        }));
    };

    const checkAll = (categoria) => {
        if (categoria === "todos") {
            setVehiculos(vehiculos.map((vehiculo) => {
                    return {
                        ...vehiculo,
                        checked: true,
                    };
            }));
            return;
        }
        if (categoria === "quitar") {
            setVehiculos(vehiculos.map((vehiculo) => {
                return {
                    ...vehiculo,
                    checked: false,
                };
            }));
            return;
        }
        setVehiculos(vehiculos.map((vehiculo) => {
            if (vehiculo.categoria === categoria) {
                    return {
                        ...vehiculo,
                        checked: true,
                    };
                }
                return vehiculo;
            }),
        );
    };

    const buscarFicha = (ficha) => {
        setFicha(ficha);
    };

    const onChangeTipo = ({value}) => {
        setTipo(value);
        if (!vehiculos.length &&
            (value === "combustible" ||
                value === "produccion-fichas" ||
                value === "relacion-gastos-ficha" ||
                value === "relacion-gastos-produccion" ||
                value === "resumen-produccion"
            )) {
            getVehiculos();
        }
    };

    const generarCierreAnual = async () => {
        setLoading(true);
        const response = await apiRequest(
            null,
            "reportes/cierre",
            "post"
        );

        if (response.success) {
            toast("Cierre de año generado con éxito.", "success");
            toggle(true);
        } else {
            toast("Error al generar el cierre de año.", "error");
        }

        setLoading(false);
    };

    const validate = (event) => {
        const form = new FormData(event.target);

        if (tipo === "cierre-ano") {
            event.preventDefault();
            generarCierreAnual();
            return;
        }

        if (
            tipo === "combustible" ||
            tipo === "produccion-fichas" ||
            tipo === "relacion-gastos-ficha" ||
            tipo === "relacion-gastos-produccion" ||
            tipo === "resumen-produccion"
        ) {
            if (!form.get("vehiculos")) {
                event.preventDefault();
                toast("Debes seleccionar al menos un vehículo.", "error");
            }
        }

        if (tipo === "produccion-empleados") {
            if (!form.get("empleados")) {
                event.preventDefault();
                toast("Debes seleccionar al menos un empleado.", "error");
            }
        }

        if (tipo === "movimiento-items") {
            if (!form.get("items")) {
                event.preventDefault();
                toast("Debes seleccionar al menos un item.", "error");
            }
        }

        if (tipo === "relacion-gastos-ficha") {
            if (!form.get("vehiculos")) {
                event.preventDefault();
                toast("Debes seleccionar al menos una ficha.", "error");
            }
        }

        if (
            tipo === "produccion-rutas" ||
            tipo === "detalle-produccion-rutas"
        ) {
            if (!form.get("rutas")) {
                event.preventDefault();
                toast("Debes seleccionar al menos una zona.", "error");
            }
        }
    };

    return (
        <form
            method='get'
            target='_blank'
            action={getLink("/imprimir/reportes")}
            onSubmit={validate}>
            <div className='popup__header'>Generar Reporte</div>
            <div className='popup__body'>
                <div className='form-group'>
                    <label>Tipo:</label>
                    <Select
                        name='reporte'
                        onChange={onChangeTipo}
                        menuPosition='fixed'
                        defaultValue={{
                            label: "Cierre de año",
                            value: "cierre-ano",
                        }}
                        options={[
                            {
                                label: "Cierre de Año",
                                value: "cierre-ano",
                            },
                            {
                                label: "Combustible",
                                value: "combustible",
                            },
                            {
                                label: "Resumen Producción Empleados",
                                value: "produccion-mensual",
                            },
                            {
                                label: "Detalle Producción Empleados",
                                value: "produccion-empleados",
                            },
                            {
                                label: "Descuentos Empleados",
                                value: "descuentos-empleados",
                            },
                            {
                                label:
                                    "Movimiento de Producción por Fichas",
                                value: "produccion-fichas",
                            },
                            {
                                label: "Relación de Gastos por Ficha",
                                value: "relacion-gastos-ficha",
                            },
                            {
                                label: "Resumen de Producción",
                                value: "resumen-produccion",
                            },
                            {
                                label: "Relación de Gastos vs Producción",
                                value: "relacion-gastos-produccion",
                            },
                            {
                                label: "Movimiento Items",
                                value: "movimiento-items",
                            },
                            {
                                label: "Producción por Zonas",
                                value: "produccion-rutas",
                            },
                            {
                                label: "Detalle Producción por Zonas",
                                value: "detalle-produccion-rutas",
                            },
                            {
                                label: "Licencias Vencidas",
                                value: "licencias-vencidas",
                            },
                            {
                                label: "Seguros Vencidos",
                                value: "seguros-vencidos",
                            },
                        ]}
                    />
                </div>
                {(tipo === "combustible" ||
                    tipo === "produccion-fichas" ||
                    tipo === "relacion-gastos-ficha" ||
                    tipo === "relacion-gastos-produccion" ||
                    tipo === "resumen-produccion") && (
                    <div>
                        <input
                            type='hidden'
                            name='tipo'
                            value='vehiculos'
                        />
                        <ReporteFechas />
                        {loading ? <Loader /> : <ReporteVehiculos
                            vehiculos={vehiculos}
                            ficha={ficha}
                            checkAll={checkAll}
                            updateList={updateList}
                            buscarFicha={buscarFicha}
                        />}
                    </div>
                )}
                {tipo === "produccion-mensual" && (
                    <div>
                        <input
                            type='hidden'
                            name='tipo'
                            value='empleados'
                        />
                        <ReporteFechas />
                        <ProduccionMensual tipo={tipo} />
                    </div>
                )}
                {(tipo === "produccion-rutas" ||
                    tipo === "detalle-produccion-rutas") && (
                    <div>
                        <input type='hidden' name='tipo' value='rutas' />
                        <ReporteFechas />
                        <ReporteRutas />
                    </div>
                )}
                {tipo === "movimiento-items" && (
                    <div>
                        <input type='hidden' name='tipo' value='items' />
                        <ReporteFechas />
                        <ReporteItems />
                    </div>
                )}
                {tipo === "produccion-empleados" && (
                    <div>
                        <input
                            type='hidden'
                            name='tipo'
                            value='empleados'
                        />
                        <ReporteFechas />
                        <ReporteEmpleados />
                    </div>
                )}
                {tipo === "descuentos-empleados" && (
                    <div>
                        <ReporteFechas />
                        <div className="form-group">
                            <label>Tipo de Descuento:</label>
                            <Select
                                name="tipo"
                                options={[{
                                    value: 'descuentos-programados',
                                    label: 'Descuentos Programados/Amonestaciones'
                                }]}></Select>
                        </div>
                        <ReporteEmpleados />
                    </div>
                )}
            </div>
            <div className='popup__footer'>
                <button
                    type='button'
                    onClick={toggle}
                    className='btn btn-plain'>
                    Cancelar
                </button>
                {loading ? (<Loader type="small" />) : (
                    <button type='submit' className='btn btn-primary'>
                        Generar
                    </button>
                )}
            </div>
        </form>
    );
}

export default withRequest(ReportesForm);
